import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { abyssColors } from '@/theme/colors';
import { formatEnumForDisplay } from '@/utils';
import { ReportInternalType } from '@/__generated__/graphql';

type ReportTypeTabsProps = {
  selectedTab: ReportInternalType;
  handleChange: (event: React.SyntheticEvent, newValue: ReportInternalType) => void;
};

export const ReportTypeTabs = ({ selectedTab, handleChange }: ReportTypeTabsProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        TabIndicatorProps={{ style: { display: 'none' } }}
        sx={{
          pt: 1,
          borderRadius: 1,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '1.2rem',
            color: abyssColors.primary[400],
          },
          '& .Mui-selected': {
            backgroundColor: abyssColors.primary[100],
            color: abyssColors.primary[700],
            borderRadius: '0.25rem',
            paddingX: '0.75rem',
            paddingY: '0.25rem',
          },
        }}
      >
        {Object.values(ReportInternalType).map((type) => (
          <Tab key={type} label={formatEnumForDisplay(type)} value={type} />
        ))}
      </Tabs>
    </Box>
  );
};
